import { FC, SVGProps } from 'react';

export const UserFilled: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.9453 26.9887C13.7333 26.9887 7 26.9887 7 22.8047C7 18.6377 13.7333 18.6377 15.9453 18.6377C18.1573 18.6377 24.8893 18.6377 24.8893 22.827C24.8893 26.9887 18.392 26.9887 15.9453 26.9887Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.9452 16.9667H15.9092C14.2825 16.9615 12.7585 16.3355 11.6172 15.2041C10.4732 14.0739 9.84788 12.5732 9.85454 10.9794C9.85454 7.68459 12.5865 5 15.9452 5C19.3052 5 22.0372 7.68459 22.0372 10.9834C22.0372 14.2821 19.3052 16.9667 15.9452 16.9667Z"
			fill="currentColor"
		/>
	</svg>
);
